import { memo, useEffect, useRef } from "react";
import { useAtomValue } from "jotai";
import { tradingViewAiOverlaysAtom } from "@/store/atoms";

const BASE_STUDIES = [
  "STD;24h%Volume",
  "STD;Accumulation_Distribution",
];

const AI_OVERLAY_STUDIES = [
  "STD;Pivot Points Standard",
  "STD;Auto Fib Retracement",
];

function buildWidgetConfig(aiOverlaysEnabled: boolean) {
  return {
    allow_symbol_change: true,
    autosize: true,
    calendar: false,
    details: false,
    hotlist: false,
    hide_side_toolbar: false,
    hide_top_toolbar: false,
    hide_legend: true,
    hide_volume: true,
    interval: "D",
    locale: "en",
    save_image: true,
    style: "1",
    symbol: "BINANCE:BTCUSD",
    theme: "dark",
    timezone: "Etc/UTC",
    backgroundColor: "#0F0F0F",
    withdateranges: true,
    range: "ALL",
    compareSymbols: [],
    studies: aiOverlaysEnabled
      ? [...AI_OVERLAY_STUDIES, ...BASE_STUDIES]
      : BASE_STUDIES,
    enable_publishing: false,
   
  };
}

function TradingViewWidget() {
  const containerRef = useRef<HTMLDivElement>(null);
  const aiOverlaysEnabled = useAtomValue(tradingViewAiOverlaysAtom);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const widgetHost = container.querySelector<HTMLDivElement>(
      ".tradingview-widget-container__widget",
    );
    if (widgetHost) {
      widgetHost.innerHTML = "";
    }

    container.querySelectorAll("script").forEach((node) => node.remove());

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    script.innerHTML = JSON.stringify(buildWidgetConfig(aiOverlaysEnabled));
    container.appendChild(script);

    return () => {
      script.remove();
      if (widgetHost) {
        widgetHost.innerHTML = "";
      }
    };
  }, [aiOverlaysEnabled]);

  return (
    <div
      ref={containerRef}
      className="tradingview-widget-container tradingview-advanced-chart h-full w-full"
      style={{ height: "100%", width: "100%" }}
    >
      <div
        className="tradingview-widget-container__widget"
        style={{ height: "100%", width: "100%" }}    />
    </div>
  );
}

export default memo(TradingViewWidget);
